module.exports = __webpack_public_path__ + "0cf9ca4ca81cf751dd0b19fa5fa80174.jpg";